'use client'

import { useMemo } from 'react'
import { ContentImage, ContentText, ContentVideo, ContentButtonDownload, ContentButtonLink } from './content-types'
import styled from 'styled-components'
import { E_CONTENT_COLUMN_TYPE } from '@/schema'

const MediaTypes = {
  'MEDIUM_IMAGE': (data) => (<ContentImage data={data} />),
  'MEDIUM_VIDEO': (data) => (<ContentVideo data={data} />)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ContentsTypes:Record<E_CONTENT_COLUMN_TYPE, (data: any) => React.ReactNode> = {
  'TEXT': (data) => (<ContentText data={data} />),
  'MEDIA': (data) => (MediaTypes[data.mediaType](data)),
  'EMPTY': () => (<div className='empty'></div>),
  'SPACER': () => (<div className='spacer'></div>),
  'BUTTON_DOWNLOAD': (data) => (<ContentButtonDownload data={data} />),
  'BUTTON_LINK': (data) => (<ContentButtonLink data={data} />)
}

const getContentByType = (content) => {
  const { columnType } = content || {}
  if (!content || !columnType || !ContentsTypes[columnType]) return <></>
  return (ContentsTypes[columnType](content))
}

export const Content = ({ content }) => {
  const ContentByType = useMemo(() => getContentByType(content), [content])

  return (
    <ContentArticle className={content.columnType.toLowerCase()} data-halign={content.horizontalAlignment}>
      {ContentByType}
    </ContentArticle>
  )
}


const ContentArticle = styled.article`
  display: flex;
  justify-content: center;
  margin: 0 auto;

  &.media {
    margin: 0 auto;
  }

	&.button_download,
	&.button_link {
		&[data-halign='LEFT'] {
			justify-content: flex-start;
			margin-left: 0;
		}
	
		&[data-halign='RIGHT'] {
			justify-content: flex-end;
			margin-right: 0;
		}
	
		&[data-halign='CENTER'] {
			justify-content: center;
			margin: 0 auto;
		}
	}
`
